import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux' //wrappa lo store le rende visibile da tutti i componenti
import store from './store'
import './bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<HelmetProvider>
 <Provider store={store}>
   <App />
 </Provider>
</HelmetProvider>
//document.getElementById('root')
   
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
